module.exports = __webpack_public_path__ + "img/bg_lines_connect.04771802.png";